// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"d81793ab","453":"5fecedb3"}[chunkId] + ".chunk.js";
};